import React, { useEffect, useState ,useRef} from 'react'
import DatePicker from "react-datepicker";
import CalendarIcon from "../../../../assets/images/Icons/calendarIcon.svg";
import { makeAjax, respStatus, url, showMessage, gameList } from '../../../../helpers/global_helper';
import { useDispatch, useSelector } from "react-redux";
import { withTranslation } from "react-i18next";
import { formatPricewithdecimal } from "../../../NumberFormat";
import InnerPopup from '../../../Popups/InnerPopup';
import BetPopup from './BetPopup';
import WinPopup from './WinPopup';
import { setTotalNoResult } from '../../../../redux/actions';
import DetailsMoPopup from './DetailsMoPopup';
import { FaCalendar } from "react-icons/fa";
import ReBetPopup from './ReBetPopup';
import BetSuccessPopup from '../../../Popups/BetSuccessPopup';
import QuickBuyPopup from '../../../LobbyContent/SubComponents/FourD/QuickBuy/QuickBuyPopup';
import BetFiftyFiftySuccessPopup from '../../../Popups/BetFiftyFiftySuccessPopup';

function History(props) {
  const dispatch = useDispatch()
  const device = useSelector(state => state.CommonConfig.device_type);
  // const [startDate, setStartDate] = useState(new Date());
  const [dateRange, setDateRange] = useState([new Date(), new Date()]);

  const [startDate, endDate] = dateRange;
  const [selectGameName, setSelectGameName] = useState("0");
  const [loading, setLoading] = useState(false)
  const pageNumber = useSelector((state) => state.paginationData.pageNumber)
  const perPage = useSelector((state) => state.paginationData.dataInOnePage)
  const [transectionData, setTransectionData] = useState([]);
  // const [gameName, setGameName] = useState([]);
  const [pageNo, setPageNo] = useState([]);
  const [showBetPopup, setBetShowPopup] = useState(false);
  const [showReBetPopup, setReBetShowPopup] = useState(false);
  const [status, setStatus] = useState("");
  const [betType, setBetType] = useState("");
  const [newDate, setNewDate] = useState("");
  const [gameId, setGameId] = useState("");
  const [game, setGame] = useState("");
  const [limitId, setLimitId] = useState("");
  const [period, setPeriod] = useState("");
  const [transectionId, setTransectionId] = useState("");
  const [winPopup, setWinPopup] = useState(false);
  const [detailsMoPopup, setdetailsMoPopup] = useState(false);
  const [historyId, setHistoryId] = useState("")
  const [datetime, setDatetime] = useState("")
  const [game_name, setGame_name] = useState("")
  const [credit, setCredit] = useState("")
  const [debit, setDebit] = useState("")
  const [coin, setCoin] = useState("")
  const [balance, setBalance] = useState("")
  const [jackpotPopup, setJackpotPopup] = useState('')
  const [nickname, setNickname] = useState();
  const [jackpotAmount, setJackpotAmount] = useState('')
  const date = new Date(startDate);

  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Adding 1 to month because it's zero-indexed
  const day = date.getDate().toString().padStart(2, '0');
  let formattedDate = `${year}-${month}-${day}`;

  const endDates = new Date(endDate);

  const endYear = endDates.getFullYear();
  const endMonth = (endDates.getMonth() + 1).toString().padStart(2, '0'); // Adding 1 to month because it's zero-indexed
  const endDay = endDates.getDate().toString().padStart(2, '0');
  let formattedEndDate = `${endYear}-${endMonth}-${endDay}`;
  const today = new Date();
  const currentYear = today.getFullYear();
  const yearStart = new Date(currentYear - 1, 0, 1);
  const isFirstLoad = useRef(true);

  const marketList = useSelector((state) => state.CommonConfig.marketList);

  const [gameName, setGameName] = useState(gameList);
  const [respData, setRespData] = useState([]);
  const [successPopup, setSuccessPopup] = useState(false);
  const [success5050Popup, setSuccess5050Popup] = useState(false);
  const [betPopupValue, setBetPopupValue] = useState({});
  const [betDetailIncompletePopup, setBetDetailIncompletePopup] = useState(false);
  const [getGameId, setBetGameId] = useState('');
  const [getBetTypeId, setBetTypeId] = useState("")
  const [marketData, setMarketData] = useState({})
  const [getGameName, setGameNames] = useState({})
  const [lastServerDate, setLastServerDate] = useState();


  useEffect(() => {
    fetchTransactionList();
    const container = document.querySelector('.informasi_tble_result');
    if (container) {
      container.scrollTop = 0;
    }
  }, [perPage, pageNumber]);

  useEffect(() => {
    makeAjax(url.TOGEL_API.getGamePeriod, {}, url.TOGEL_MS_EXT).then((response) => {
      if (response.status != respStatus["SUCCESS"]) {
        if (response.code != "validation_error") {
          showMessage(response);
          return;
        }
        showMessage(response);
        return;
      }
      setMarketData(response.data.market);
      setGameNames(response.data.games);

    });
  }, [])

 
 const fetchTransactionList = () => {
  if (!formattedEndDate || formattedEndDate === "1970-01-01") return;

  setLoading(true);

  let reqData = {
    type: "history_results",
    page: pageNumber,
    date: formattedDate,
    endDate: formattedEndDate,
    game_id: parseInt(selectGameName),
    length: perPage,
  };

  makeAjax(url.PLAYER_API.listTransaction, reqData, url.PLAYER_MS_EXT)
    .then((response) => {
      if (response.status !== respStatus.SUCCESS) {
        showMessage(response);
        setLoading(false);
        return;
      }

       // ✅ Set server date ONLY once
      if (isFirstLoad.current && response.data.serverDateTime) {
        const serverDate = new Date(response.data.serverDateTime);
          setDateRange([serverDate, serverDate]);
          const serverNewDates = new Date(serverDate);
          const endYear = serverNewDates.getFullYear();
          const endMonth = (serverNewDates.getMonth() + 1).toString().padStart(2, '0'); // Adding 1 to month because it's zero-indexed
          const endDay = serverNewDates.getDate().toString().padStart(2, '0');
          formattedDate = `${endYear}-${endMonth}-${endDay}`;
          formattedEndDate = `${endYear}-${endMonth}-${endDay}`;
          setLastServerDate(formattedEndDate);
          isFirstLoad.current = false;
          fetchTransactionList()      
      }

      setLoading(false);
      setTransectionData(response.data.dataHistory);
      dispatch(setTotalNoResult(response.data.allHistory.total));
      setPageNo(response.data.page)

    });
};

  const handleJackpotOpen = (gameId, nickname, amount, game) => {
    setJackpotPopup(true);
    setGameId(gameId);
    setNickname(nickname);
    setJackpotAmount(amount);
    setGame(game);

  }

  const CustomInput = ({ value, onClick }) => (
    <div style={{ position: "relative" }} className="custom_calendar trans">
      <input
        type="text"
        value={value}
        onClick={onClick} // This opens the calendar on input click
        readOnly // Prevent direct text input
      />
      <button
        onClick={onClick} // This also opens the calendar on icon click

        style={{
          position: "absolute",
          right: "10px",
          top: "50%",
          transform: "translateY(-50%)",
          cursor: "pointer"
        }}
      >
        {/* <img src={CalendarIcon} alt="" /> */}
        <FaCalendar />

      </button>
    </div>
  );

  const handleBetOpen = (
    transId, status, bettype, gameId,
    game, date, limitId, period
  ) => {
    setBetShowPopup(true);
    setTransectionId(transId);
    setStatus(status);
    setBetType(bettype);
    setGameId(gameId);
    setGame(game);
    setNewDate(date);
    setLimitId(limitId);
    setPeriod(period);
  };


  const handleWinOpen = (transId, status, bettype,
    gameId, game, date, limitId, period
  ) => {
    setWinPopup(true);
    setTransectionId(transId);
    setStatus(status);
    setBetType(bettype);
    setGameId(gameId);
    setGame(game);
    setNewDate(date);
    setLimitId(limitId);
    setPeriod(period);
  };

  const handleReBetPopupOpen = (transId, status, bettype,
    gameId, game, date, limitId, period, betTypeId) => {
    setReBetShowPopup(true);
    setTransectionId(transId);
    setStatus(status);
    setBetType(bettype);
    setGameId(gameId);
    setGame(game);
    setNewDate(date);
    setLimitId(limitId);
    setPeriod(period);
    setBetTypeId(betTypeId);
  }

  const handleDetailsOpen = (
    historyId, datetime, game_name, period,
    statusLabel, credit, debit, coin, balance
  ) => {
    setdetailsMoPopup(true);
    setHistoryId(historyId);
    setDatetime(datetime);
    setGame_name(game_name);
    setPeriod(period);
    setStatus(statusLabel);
    setCredit(credit);
    setDebit(debit);
    setCoin(coin);
    setBalance(balance);
    document.body.style.overflow = 'hidden';
  };


  const handleGameSelectOptions = (e) => {
    const selectedValue = e.target.value;
    setSelectGameName(selectedValue);
  };

  const handlePopupClose = () => {
    setRespData([]);
    setSuccessPopup(false);
    setBetDetailIncompletePopup(false)
    setSuccess5050Popup(false)
  }

  const handleSearchData = () => {
    const container = document.querySelector('.informasi_tble_result');
    if (container) {
      container.scrollTop = 0;
    }
    props.handlePageNo();

    fetchTransactionList();
  };
  const startIndex = (pageNo - 1) * perPage;

  useEffect(() => {
    props.handlePageNo();
    fetchTransactionList();
  }, [success5050Popup, successPopup, betDetailIncompletePopup])

  const handleDateChange = (update) => {
    let [start, end] = update;

    if (start && end) {
      const diffTime = Math.abs(end - start);
      const diffDays = diffTime / (1000 * 60 * 60 * 24);

      if (diffDays > 6) {
        showMessage("You can only select up to 7 days range.");
        end = new Date(start);
        end.setDate(start.getDate() + 6);
      }
    }

    setDateRange([start, end]);
  };

  return (
    <div className='trasaction_popup'>

      <div className="trasaction_top_bar">
        {/* <div className="calendar">
          <DatePicker
            // showIcon
            customInput={<CustomInput />}
            selected={startDate}
            onChange={(date) => setStartDate(date)}
            dateFormat="yyyy-MM-dd"
            maxDate={new Date()}
          />
        </div> */}
        {device === "Desktop" ? (
          <div className="calendar">
            <DatePicker
              customInput={<CustomInput />}
              selectsRange={true}     // enable range selection
              startDate={startDate}
              endDate={endDate}
              // onChange={handleDateChange}
              monthsShown={2}
              isClearable={false}      // optional: adds clear (x) button
              dateFormat="yyyy/MM/dd"
              maxDate={lastServerDate}
              placeholderText="Select date range"
              minDate={yearStart}
              dayClassName={(date) =>
                        lastServerDate &&
                        date.toDateString() === new Date(lastServerDate).toDateString()
                        ? "server-date-bold"
                        : undefined
                    }
              selected={startDate} onChange={handleDateChange} 
            />
          </div>
        ) : (
          <div className="calendar">
            <DatePicker
              customInput={<CustomInput />}
              selectsRange={true}     // enable range selection
              startDate={startDate}
              endDate={endDate}
              // onChange={handleDateChange}
              monthsShown={2}
              isClearable={false}      // optional: adds clear (x) button
              dateFormat="MM/dd"
              maxDate={lastServerDate}
              placeholderText="Select date range"
              minDate={yearStart}
               dayClassName={(date) =>
                        lastServerDate &&
                        date.toDateString() === new Date(lastServerDate).toDateString()
                        ? "server-date-bold"
                        : undefined
                    }
              selected={startDate} onChange={handleDateChange} 
            />
          </div>
        )}
        {/* <div className="all_game_dropdown">
          <select className="dropdown" value={selectGameName} onChange={handleGameSelectOptions}>
            <option value="0">All</option>
            {!loading &&
              gameName.length > 0 &&
              gameName?.map(({ game_id, game_name }) => (
                <option key={game_id} value={game_id}>
                  {game_name}
                </option>
              ))
            }
          </select>
        </div> */}
        <div className="all_game_dropdown">
          <select className="dropdown" value={selectGameName} onChange={handleGameSelectOptions}>
            <option value="0">All</option>
            {!loading &&
              marketList.length > 0 &&
              marketList.map(({ game_id, game_name }) => (
                <option key={game_id} value={game_id}>
                  {game_name}
                </option>
              ))
            }
          </select>
        </div>
        <div className="search">
          <button onClick={handleSearchData} >{props.t("search")}</button>
        </div>

      </div>
      {
        device === "Desktop" ?
          <>
            {/* table */}
            <div className="informasi_tble_result">
              <table >
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>{props.t('history')} ID</th>
                    <th>{props.t('date')}</th>
                    <th>{props.t('game')}</th>
                    <th>{props.t('period')}</th>
                    <th>{props.t('status')}</th>
                    <th>{props.t('credit')}</th>
                    <th>{props.t('debit')}</th>
                    <th>{props.t('coin')}</th>
                    <th>{props.t('Re Bet')}</th>
                    <th>{props.t('balance')}</th>
                    <th>{props.t('coin_reward')}</th>
                  </tr>
                </thead>
                <tbody>
                  {!loading &&
                    (
                      transectionData.length == 0 ?
                        <tr className="table_data_empty_row">
                          <td colSpan="11">{props.t("data_not_found")}</td>
                        </tr>

                        :
                        transectionData.map((value, index) => (
                          <tr
                            key={index}
                            className={index % 2 === 0 ? "even-row" : "odd-row"}
                          >
                            <td>{startIndex + index + 1}</td>
                            <td>{value.id}</td>
                            <td>{value.datetime}</td>
                            <td>{value.game_name}</td>
                            <td>{value.game_id == 0 ? 0 : value.periode}</td>
                            <td>
                              {value.status === 21 ? (
                                <span className="link" onClick={() => handleBetOpen(
                                  value.trans_id,
                                  value.status,
                                  value.bettype,
                                  value.game_id,
                                  value.game_name,
                                  value.datetime,
                                  value.limit_id,
                                  value.period)}>
                                  {value.bettype > 1000 ? "Bet Full" : "Bet " + props.t('disc')}
                                </span>
                              ) : value.status === 22 ? (
                                <span className="link" onClick={() => handleWinOpen(
                                  value.trans_id,
                                  value.status,
                                  value.bettype,
                                  value.game_id,
                                  value.game_name,
                                  value.datetime,
                                  value.limit_id,
                                  value.period)}>
                                  {props.t('win')}
                                </span>
                              ) : value.status === 30 ? (
                                props.t("win_regular_jackpot")
                              ) : (
                                props.t(`action${value.act}`)
                              )}
                            </td>
                            <td>{formatPricewithdecimal(value.credit)}</td>
                            <td>{formatPricewithdecimal(value.debit)}</td>
                            <td>{formatPricewithdecimal(value.coin)}</td>
                            <td className='reBetButton'>
                              {(value.status === 21) ? (
                                <button onClick={() => handleReBetPopupOpen(
                                  value.trans_id,
                                  value.status,
                                  value.bettype,
                                  value.game_id,
                                  value.game_name,
                                  value.datetime,
                                  value.limit_id,
                                  value.period,
                                  value.betTypeId)}>
                                  {props.t('Re-Bet')}
                                </button>
                              ) : ("-")}
                            </td>
                            <td>{formatPricewithdecimal(value.balance)}</td>
                            <td>{formatPricewithdecimal(value.reward_balance)}</td>


                          </tr>
                        ))
                    )
                  }
                </tbody>
              </table>
            </div>
          </>
          :
          <div className='container'>
            <table>
              <thead>
                <tr>
                  <th>{props.t("date")}</th>
                  <th>{props.t("game")}</th>
                  <th>{props.t("period")}</th>
                  <th>{props.t("status")}</th>
                  <th>{props.t("balance")}</th>
                  <th>
                    {props.t("desc")}
                  </th>
                </tr>
              </thead>
              <tbody>
                {transectionData.length === 0 ? (
                  <tr className="table_data_empty_row">
                    <td colSpan="11">{props.t("data_not_found")}</td>
                  </tr>
                ) : (
                  transectionData.map((value, index) => (
                    <tr
                      key={index}
                      className={index % 2 === 0 ? "even-row" : "odd-row"}
                    >
                      <td>{value.datetime}</td>
                      <td>{value.game_name}</td>
                      <td>{value.game_id == 0 ? 0 : value.periode}</td>
                      <td>
                        {value.status === 21 ? (
                          <span className="link" onClick={() => handleBetOpen(
                            value.trans_id,
                            value.status,
                            value.bettype,
                            value.game_id,
                            value.game_name,
                            value.datetime,
                            value.limit_id,
                            value.period
                          )}>
                            {((value.typeGame === 5 || value.typeGame === 55) && value.status === 21)
                              ? (value.bettype > 1000 ? "Bet Full" : "Bet " + props.t('disc'))
                              : value.status}
                          </span>
                        ) : value.status === 22 ? (
                          <span className="link" onClick={() => handleWinOpen(
                            value.trans_id,
                            value.status,
                            value.bettype,
                            value.game_id,
                            value.game_name,
                            value.datetime,
                            value.limit_id,
                            value.period
                          )}>
                            {props.t("win")}
                          </span>
                        ) : value.status === 30 ? (
                          <span className="link" onClick={() => handleJackpotOpen(
                            value.game_id,
                            value.nickname,
                            value.amount,
                            value.game_name
                          )}>
                            {props.t("tablejackpot")}
                          </span>
                        ) : (
                          props.t(`action${value.act}`)
                        )}
                      </td>
                      <td>{formatPricewithdecimal(value.balance)}</td>
                      <td className='reBetButton'>
                        <span>

                          {(value.status === 21) && (
                            <button onClick={() => handleReBetPopupOpen(
                              value.trans_id,
                              value.status,
                              value.bettype,
                              value.game_id,
                              value.game_name,
                              value.datetime,
                              value.limit_id,
                              value.period,
                              value.betTypeId)}>
                              {props.t('Re-Bet')}
                            </button>
                          )}
                        </span>
                        <br />
                        <span className="link " onClick={() => {
                          const statusLabel = value.status === 21 ? "Bet"
                            : value.status === 22 ? "Win"
                              : value.status === 30 ? "Jackpot"
                                : props.t(`action${value.act}`);
                          handleDetailsOpen(value.id, value.datetime, value.game_name, value.game_id == 0 ? 0 : value.periode, statusLabel, value.credit, value.debit, value.coin, value.balance)
                        }}>
                          <button className='details-btn' style={{ marginTop: value.status === 21 ? "2px" : "0", }}>Details</button>
                        </span>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
      }
      {
        /*---Bet poupu --*/
        showBetPopup && (
          <InnerPopup
            modalTitle={`BET ${game}`}
            modalHeader={true}
            onCloseModal={() => setBetShowPopup(false)}
          >
            <BetPopup
              transId={transectionId}
              status={status}
              bettype={betType}
              gameId={gameId}
              date={newDate}
              limitId={limitId}
              period={period}
            />
          </InnerPopup>
        )
      }
      {
        /*---Bet poupu --*/
        showReBetPopup && (
          <InnerPopup
            modalTitle={`RE-BET ${game} - ${parseInt(marketData[gameId]) + 1}`}
            modalHeader={true}
            onCloseModal={() => setReBetShowPopup(false)}
          >
            <ReBetPopup
              transId={transectionId}
              status={status}
              bettype={betType}
              gameid={gameId}
              date={newDate}
              limitId={limitId}
              period={period}
              setPeriod={parseInt(marketData[gameId]) + 1}
              betTypeId={getBetTypeId}
              marketNameId={getGameName}
              setReBetShowPopup={setReBetShowPopup}
              setRespData={setRespData}
              setSuccessPopup={setSuccessPopup}
              setBetGameId={setBetGameId}
              setBetDetailIncompletePopup={setBetDetailIncompletePopup}
              setBetPopupValue={setBetPopupValue}
              setSuccess5050Popup={setSuccess5050Popup}
            />
          </InnerPopup>
        )
      }
      {successPopup && (
        <div className="popup-overlay ">
          <BetSuccessPopup
            response={respData}
            getGameId={getGameId}
            onClose={handlePopupClose}
          />
        </div>
      )}
      {betDetailIncompletePopup && (
        <div className="popup-overlay ">
          <QuickBuyPopup onClose={handlePopupClose} response={respData} />
        </div>
      )}
      {success5050Popup && (
        <div className="popup-overlay ">
          <BetFiftyFiftySuccessPopup
            response={respData}
            betValue={betPopupValue}
            getGameId={getGameId}
            onClose={handlePopupClose}
          />
        </div>
      )}
      {
        /*---win poupu --*/
        winPopup && <InnerPopup modalTitle={`WIN ${game}`} modalHeader={true} onCloseModal={() => setWinPopup(false)}>
          <WinPopup
            transId={transectionId}
            act={status}
            bettype={betType}
            gameId={gameId}
            date={newDate}
            limitId={limitId}
            period={period}
          />
        </InnerPopup >
      }

      {detailsMoPopup && (
        <InnerPopup
          modalTitle={props.t("detail")}
          modalHeader={true}
          onCloseModal={() => setdetailsMoPopup(false)}
        >
          <DetailsMoPopup
            historyId={historyId}
            datetime={datetime}
            game_name={game_name}
            period={period}
            status={status}
            credit={credit}
            debit={debit}
            coin={coin}
            balance={balance}
          />
        </InnerPopup>
      )}
    </div>
  )
}

export default withTranslation()(History)
